import { Box, IconButton, Menu, SxProps, Theme, styled } from '@mui/material';
import React, { JSX } from 'react';
import { Hub, Plus, Pour, Sensor } from '../icons';
import { StyledMenuItem } from '../pour-card';
import { t } from 'i18next';
import { useNavigate } from 'react-router';
import { routesDetails } from '@/constants';

export const StyledAddBtn = styled(IconButton)(({ theme, ...otherProps }) => ({
  backgroundColor: theme.palette.primary.darker,
  boxShadow:
    '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)',
  width: '56px',
  height: '56px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
  '& svg': {
    transition: 'transform 0.3s ease-in-out',
    transform: otherProps['aria-expanded'] ? 'rotate(45deg)' : '',
  },
}));

interface FloatingAddBtnContainerOption {
  
  name: string;
  onClick: () => void;
  icon: JSX.Element;
  disabled?: boolean;
}

interface FloatingAddBtnContainerProps {
  sx?: SxProps<Theme>;
  options: FloatingAddBtnContainerOption[]

}

const FloatingAddBtnContainer = ({
  sx,
  options,
}: FloatingAddBtnContainerProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ ...sx }}>
      <StyledAddBtn
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={options.length===1? options[0].onClick: handleClick}
      >
        <Plus />
      </StyledAddBtn>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={handleClose}
      >
        {options.length>1 && options
          .filter(option => !option.disabled)
          .map(option => (
            <StyledMenuItem key={option.name} onClick={option.onClick} disabled={option.disabled}>
              <span>{option.icon}</span>
              {option.name}
            </StyledMenuItem>
          ))}
      </Menu>
    </Box>
  );
};

export default FloatingAddBtnContainer;
